import { Component, Inject } from '@angular/core';
import { MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA, MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';

export interface ActionDialogData {
    [index: string]: any;
}

@Component({
    selector: 'app-action-dialog',
    templateUrl: './action-dialog.component.html',
    styleUrls: ['./action-dialog.component.scss'],
})
export class ActionDialogComponent {
    value: number = null;

    constructor(public dialogRef: MatDialogRef<ActionDialogComponent>, @Inject(MAT_DIALOG_DATA) public data: ActionDialogData) {}

    onNoClick(): void {
        this.dialogRef.close({ status: false });
    }

    onYesClick(): void {
        this.dialogRef.close({ status: true, value: this.value });
    }
}
